import React from 'react';
import { Segment, Form } from 'semantic-ui-react';
import { SidebarPortal, Field } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import MapLibreData from './MapLibreData';
import MapLibreView from './MapLibreView';

const MapLibreEdit = (props) => {
  const { selected, onChangeBlock, block, data } = props;

  return (
    <div>
      <SidebarPortal selected={selected}>
          <header className="header pulled">
            <h2>Map Libre</h2>
          </header>
	<MapLibreData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
	/>
        <div style={{
		 'width': '100%',
		 'textAlign': 'center'
        }}>
	</div>
      </SidebarPortal>
      <MapLibreView {...props} />
    </div>
  );
};

export default MapLibreEdit;
